// https://stackoverflow.com/questions/1985260/rotate-the-elements-in-an-array-in-javascript/33451102#33451102
const rotateArray = (arr, count) => {
  count -= arr.length * Math.floor(count / arr.length);
  arr.push.apply(arr, arr.splice(0, count));
  return arr;
};

export default rotateArray;
